<div class="card modal-card">
    <!-- Header -->
    <div class="card-header modal-header d-flex justify-content-between align-items-center">
      <h2 class="card-title mb-0 text-white"><b>Agregar Riesgo</b></h2>
      <button mat-icon-button (click)="onClose()"> <mat-icon>clear</mat-icon> </button>
    </div>
        <div class="card-body">
      <form [formGroup]="formRiesgo" class="row g-3"> 
     
        <div class="col-12 col-md-6">
          <label class="form-label" for="modal-riesgo-fase-deteccion">Fase de Detección</label>
          <select id="modal-riesgo-fase-deteccion" class="form-select" formControlName="faseDeteccionCtrl" [(ngModel)]="riesgo.id_fase_deteccion">
            <option *ngFor="let item of faseDeteccion" [value]="item.id_fase">
              {{item.nombre_faseDeteccion}}
            </option>
          </select>
       </div>
        
        <div class="col-12 col-md-6">
          <label class="form-label" for="modal-riesgo-descripcion">Descripción</label>
          <textarea id="modal-riesgo-descripcion" class="form-control" rows="3" formControlName="descripcionCtrl" [(ngModel)]="riesgo.descripcion"></textarea>
        </div>
         
        <div class="col-12 col-md-6">
          <label class="form-label" for="modal-riesgo-causa-raiz">Causa Raíz</label>
          <textarea id="modal-riesgo-causa-raiz" class="form-control" rows="3" formControlName="causaRaizCtrl" [(ngModel)]="riesgo.causa_raiz"></textarea>
        </div>
         
        <div class="col-12 col-md-6">
          <label class="form-label" for="modal-riesgo-probabilidad">Probabilidad</label>
          <select id="modal-riesgo-probabilidad" class="form-select" formControlName="probabilidadCtrl" [(ngModel)]="riesgo.id_probabilidad">
            <option *ngFor="let item of probabilidad" [value]="item.id_probabilidad">
              {{item.nombre}}
            </option>
          </select>
        </div>
         
        <div class="col-12 col-md-6">
          <label class="form-label" for="modal-riesgo-impacto">Impacto</label>
          <select id="modal-riesgo-impacto" class="form-select" formControlName="impactoCtrl" [(ngModel)]="riesgo.id_impacto" (change)="calcularProbabilidadImpacto()">
            <option *ngFor="let item of impacto" [value]="item.id_impacto">
              {{item.descripcion}}
            </option>
          </select>
        </div>
          
        <div class="col-12 d-flex align-items-center">
          <label class="form-label mb-0">Severidad Riesgo:</label>
          <span class="ms-2 badge-severidad" [style.backgroundColor]="colorSeveridad"></span>
          <span class="ms-2">{{nombreSeveridad}}</span>
        </div>
         
        <div class="col-12 col-md-6">
          <label class="form-label" for="modal-riesgo-estrategia">Estrategia a seguir</label>
          <select id="modal-riesgo-estrategia" class="form-select" formControlName="estrategiaCtrl" [(ngModel)]="riesgo.id_estrategia">
            <option *ngFor="let item of estrategia" [value]="item.id_estrategia">
              {{item.estrategia}}
            </option>
          </select>
        </div>
       
        <div class="col-12 col-md-6">
          <label class="form-label" for="modal-riesgo-fecha-identificacion">Fecha de Identificación</label>
          <input id="modal-riesgo-fecha-identificacion" type="date" class="form-control" formControlName="fechaCtrl" [(ngModel)]="riesgo.fecha_identificacion">
        </div>
         
        <div class="col-12 col-md-6">
          <label class="form-label" for="modal-riesgo-periodicidad">Periodicidad</label>
          <select id="modal-riesgo-periodicidad" class="form-select" formControlName="periodicidadCtrl" [(ngModel)]="riesgo.id_periodicidad">
            <option *ngFor="let item of periodicidad" [value]="item.id_periodicidad">
              {{item.descripcion}}
            </option>
          </select>
        </div>
         
        <div class="col-12">
          <label class="form-label" for="modal-riesgo-responsable-recurso">Responsable/Recurso</label>
          <input id="modal-riesgo-responsable-recurso" type="text" class="form-control" formControlName="responsableRecursoCtrl" [(ngModel)]="riesgo.responsable_recurso">
        </div>
       
        <div class="col-12">
          <label class="form-label" for="modal-riesgo-acciones-seguir">Acciones a Seguir</label>
          <input id="modal-riesgo-acciones-seguir" type="text" class="form-control" formControlName="accionesSeguirCtrl" [(ngModel)]="riesgo.acciones_seguir">
        </div>
  
      </form>
    </div>
   
    <div class="modal-footer d-flex justify-content-end">
      <button type="button" class="btn btn-danger" (click)="onClose()">Cancelar</button>
      <button type="button" class="btn btn-success" [disabled]="formRiesgo.invalid" (click)="guardaActualizaRiesgo()">Guardar</button>
    </div>
  </div>
  